import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Input } from '@/components/ui/input';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
  /** Ties the field to a <Label htmlFor>. Optional: existing callers sit in
   *  inline bars where the placeholder is the only affordance. */
  id?: string;
  /** Overrides the default fixed width. A grid cell wants w-full, an inline
   *  filter bar wants the fixed width it has always had. */
  className?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search assessments',
  debounceMs = 300,
  id,
  className = 'w-[240px]',
}: SearchInputProps) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChange(localValue);
      }
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [localValue, debounceMs, onChange, value]);

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        id={id}
        type="text"
        placeholder={placeholder}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className={`${className} pl-9`}
      />
    </div>
  );
}
